import { render, staticRenderFns } from "./KBProductsList.vue?vue&type=template&id=3fd8d22c&"
import script from "./KBProductsList.vue?vue&type=script&lang=ts&"
export * from "./KBProductsList.vue?vue&type=script&lang=ts&"
import style0 from "./KBProductsList.vue?vue&type=style&index=0&id=3fd8d22c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCheckbox})
